module.exports = __webpack_public_path__ + "media/images/dhl-010ebd373e1e768a65a844387233c858.png";